<template>
  <div>
    <el-dialog
      title="员工授权"
      :lock-scroll="true"
      :visible.sync="dialogFormVisible"
      width="1100px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <section class="dialogContent">
        <qx-search-box
          class="searchBox"
          :searchBoxData="searchBoxData"
          @sub="sub"
          :inDialog="true"
          permpisionsQuery=""
        />
        <TableBox :isRadio="isRadio" ref="tableBox" />
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button @click="cancle">取 消</el-button>
        <el-button type="primary" @click="choose" :loading="subLoading">确定</el-button>
      </section>
    </el-dialog>
    <div
      v-show="!customShow"
      class="chooseShowBox posire cur"
      :class="{active: Boolean(this.resultVal.linkman)}"
      @click="showChooseDialog"
    >
      {{isRadio ? (this.resultVal.linkman || '请选择') : '请选择'}}
      <i class="el-icon-arrow-down posiab downIcon" />
    </div>
  </div>
</template>

<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  model: {
    prop: 'resultVal', // 父级传进来的值
    event: 'change',
  },
  props: {
    resultVal: {
      default: () => ({}),
    },
    isRadio: {
      type: Boolean,
      default: false,
    },
    otherSearchData: {
      type: Object,
      default: () => ({}),
    },
    customShow: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
      text: '',
      originData: {},
      searchBoxData: {
        form: [
          { // 角色名称
            label: '角色名称',
            value: 'roleName',
            type: 'input',
            placeholder: '请输入角色名称',
          },
        ],
      },
    };
  },
  methods: {
    show (item) {
      this.dialogFormVisible = true;
      this.originData = item;
      if (item) {
        if (this.$refs.searchBox) {
          this.$refs.searchBox.sub();
        }
        const selectResult = [];
        const roleIds = item.roleIds.split(',');
        const roleNames = item.roleNames.split(';');
        roleIds.forEach((id, index) => {
          if (id) {
            selectResult.push({
              roleId: Number(id),
              roleName: roleNames[index],
            });
          }
        });
        this.$nextTick(() => {
          this.$refs.tableBox.setSelectVal(selectResult);
        });
      }
    },

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      this.$refs.tableBox.saveSearchBoxData({
        ...this.otherSearchData,
        ...searchBoxData,
      });
    },
    showChooseDialog () {
      if (this.disabled) {
        return;
      }
      this.dialogFormVisible = true;
      if (this.$refs.searchBox) {
        this.$refs.searchBox.sub();
      }
      this.$nextTick(() => {
        this.$refs.tableBox.setSelectVal(this.resultVal);
      });
    },
    cancle () {
      this.$refs.tableBox.clearSelect();
      this.dialogFormVisible = false;
    },
    choose () {
      if (this.isRadio) {
        this.$emit('change', this.$refs.tableBox.getSelectRadioData());
      } else {
        this.$emit('change', this.$refs.tableBox.getSelectData());
      }
      this.dialogFormVisible = false;
    },
    delCheckboxSelect (item) {
      this.resultVal.splice(this.resultVal.indexOf(item), 1);
      this.$emit('change', this.resultVal);
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent{
  padding-bottom: 24px;
}
.searchBox{
  ::v-deep .customForm{
    margin: 0;
  }
}
::v-deep .el-radio-group{
  width: 100%;
}
.chooseShowBox{
  height: 32px;
  line-height: 32px;
  width: 240px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  padding: 0 15px;
  border-radius: 4px;
  color: #C0C4CC;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .downIcon{
    font-size: 14px;
    right: 5px;
    top: 8px;
    color: #C0C4CC;
  }
}
.active{
  color: #333;
}
</style>
